export const DMS_MODULE = 'Sestavy';
export const NAME = 'AdvancePayment';
export const EXPORT_FILE_NAME = 'AdvancePayment.xlsx';
export const CRUMB_LABEL_KEY = 'AdvancePayment';
export const MAX_DAYS = 31;
export const MIN_DAYS = 0;
